
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsroom/[article]",
      function () {
        return require("private-next-pages/newsroom/[article].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsroom/[article]"])
      });
    }
  